const template = {
  specificationHeader: 'Product Features',
  headerLink: id => `/product/${id}`,
  headerText: 'Read more',
  freeDelivery: 'Free delivery available',
  eligibleDelivery: 'Free delivery available',
  collectInStore: 'Eligible for store collection',
  installAndRecycle: 'Installation & recycling available',
  yesLabel: 'Yes',
  pageTypeBrowse: 'browse',
  pageTypeSearch: 'search',
  browseAddToTrolleyOrigin: 'PLP:productCard',
  searchAddToTrolleyOrigin: 'SLP:productCard',
  clothingLayout: 'clothing',
  fashionTemplate: 'fashion',
  whiteGoodTemplate: 'white goods',
  defaultTemplate: 'default',
  searchRelevancyHeader: 'See more related results for',
  secondaryDataArray: attributes => {
    const { variants } = attributes
    const secondaryData = []

    const freeDelivery = attributes.freeDelivery && attributes.deliverable
    const eligibleDelivery = !attributes.freeDelivery && attributes.deliverable
    const collectionInStore =
      attributes.reservable &&
      variants &&
      variants.serviceStorePickup &&
      variants.serviceStorePickup.length > 0 &&
      variants.serviceStorePickup[0].variantLabel
    const installAndRecycle =
      variants &&
      variants.serviceInstallation &&
      variants.serviceInstallation.length > 0 &&
      variants.serviceInstallation.find(a => a.variantLabel === template.yesLabel)

    if (freeDelivery) {
      secondaryData.push(template.freeDelivery)
    }
    if (!freeDelivery && eligibleDelivery) {
      secondaryData.push(template.eligibleDelivery)
    }
    if (collectionInStore) {
      secondaryData.push(template.collectInStore)
    }
    if (installAndRecycle) {
      secondaryData.push(template.installAndRecycle)
    }
    return secondaryData
  }
}

export default template
